module.exports = __webpack_public_path__ + "img/check.55dd2c04.svg";